import { SQLiteDBConnection } from '@capacitor-community/sqlite';

export class SqliteObjectWrapper {
  constructor(private db: SQLiteDBConnection) {}

  async executeSql(sql: string, params: any[] = []): Promise<any> {
    const sqlTrimmed = sql.trim().toUpperCase();
    const safeParams = params.length > 0 ? params : undefined;

    try {
      if (
        sqlTrimmed.startsWith('CREATE') ||
        sqlTrimmed.startsWith('DROP') ||
        sqlTrimmed.startsWith('ALTER')
      ) {
        await this.db.run(sql, safeParams);
        return this.buildRowsResult([]);
      }

      if (
        sqlTrimmed.startsWith('INSERT') ||
        sqlTrimmed.startsWith('UPDATE') ||
        sqlTrimmed.startsWith('DELETE')
      ) {
        const result = await this.db.run(sql, safeParams);
        return this.buildRowsResult([], result.changes?.changes ?? 0);
      }

      // SELECT, PRAGMA y cualquier otra consulta que retorne filas
      const result = await this.db.query(sql, safeParams);
      return this.buildRowsResult(result.values ?? []);
    } catch (error) {
      console.error('[SqliteObjectWrapper] executeSql error:', sql, error);
      throw error;
    }
  }

  private buildRowsResult(rows: any[], rowsAffected = 0): any {
    return {
      rows: {
        length: rows.length,
        item: (index: number) => rows[index],
      },
      rowsAffected,
    };
  }

  async tableExists(tableName: string): Promise<boolean> {
    try {
      const result = await this.db.query(
        `SELECT name FROM sqlite_master WHERE type='table' AND name=?`,
        [tableName]
      );
      return (result.values ?? []).length > 0;
    } catch {
      return false;
    }
  }

  async close(): Promise<void> {
    // El ciclo de vida lo maneja SqliteWrapperService
  }
}
